import { cloneDeep } from '../utils/cloneDeep.js';
import { deleteStepFromGraph } from './deleteStepFromGraph.js';

export const cleanGraphForWorkflowRun = (oldGraph = {}, steps = []) => {
  let graph = cloneDeep(oldGraph);
  const skippedStepIds = steps?.filter((step) => step?.isSkipped === true).map((step) => step?.id);
  const stepsToRemove = new Set([...skippedStepIds]);
  stepsToRemove.forEach((stepId) => {
    graph = deleteStepFromGraph(graph, stepId);
  });
  return graph;
};
